<template>
    <div>
        <loading :active.sync="loadingApp" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">List Komisi</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div class="section detail-transaction-section pt-2" style="--height:90px;">
                <div class="detail-card text-center">
                    <h1 style="font-size:40px;" class="mt-2 mb-0"><small style="font-size:15px;">Rp</small> {{customer.komisi}}</h1>
                    <p class="mb-1">Total Komisi</p>
                </div>
            </div>
            <!-- <div class="section mt-2">
                <router-link :to="{name:'withdrawal'}" class="btn btn-primary btn-block"><ion-icon name="archive"></ion-icon> Tarik Komisi</router-link>
            </div> -->
            <div class="section full mt-2">
                <div v-if="komisi.data.length > 0">
                    <ul class="listview image-listview-product inset">
                        <li v-for="item in komisi.data" :key="item.id">
                            <div class="item pl-3 pr-3">
                                <div class="in">
                                    <div style="width: 90%;">
                                        <h4>{{ item.description }}</h4>
                                        <footer>{{ item.created_at }}</footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <div class="chip chip-success ml-05 mb-05" v-if="item.type == '+'">
                                            <span class="chip-label">+ Rp {{ item.nominal | rupiah }}</span>
                                        </div>
                                        <div class="chip chip-danger ml-05 mb-05" v-else>
                                            <span class="chip-label">- Rp {{ item.nominal | rupiah }}</span>
                                        </div>
                                        <h4 class="ml-05 mb-05">Rp {{ item.komisi | rupiah }}</h4>
                                    </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="m-2 text-center" v-if="komisi.next_page_url">
                        <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary rounded mr-1 mb-1'" @click.native="paginateKomisi(komisi.next_page_url)">Lihat lebih banyak</ButtonLoader>
                    </div>
                </div>
                <div class="text-center" style="margin-top:50px;" v-else>
                    <img :src="require('@/assets/image/404.svg')" alt="404" class="w-75 mb-3"><br>
                    <i>Data belum tersedia</i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $axios from './../../api.js'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            affiliate_id: '',
            loadingApp: true,
            loadingButton: false,
            komisi:{
                data: []
            },
            komisi_total: 0
        }
    },
    computed: {
        ...mapState(['toast','VUE_ENV', 'customer', 'setting'])
    },
    methods:{
        ...mapActions(['getCustomer','getSetting']),
        paginateKomisi(url = ''){
            this.getCustomer()
            this.loadingButton = true
            $axios.get(url ? url:'/referral/komisi')
            .then(response => {
                if(!this.komisi.data){
                    this.komisi = response.data.data
                }else{
                    this.komisi.data.push(...response.data.data.data)
                    this.komisi.next_page_url = response.data.data.next_page_url
                }
                this.loadingButton = false
                this.loadingApp = false
            }).catch(() => {
                this.loadingButton = false
                this.loadingApp = false
            })
        },
    },
    mounted(){
        this.paginateKomisi()
    },
    destroyed(){
        this.$store.commit('RESET_TOAST')
    }
}
</script>